import React from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { CheckCircle, Cancel, HelpOutline } from "@mui/icons-material";

const AlertBox = ({ open, type, title, message, onClose, onConfirm }) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return (
          <CheckCircle
            fontSize="medium"
            sx={{
              fontSize: 60,
              color: "green",
            }}
          />
        );
      case "error":
        return (
          <Cancel
            fontSize="medium"
            sx={{
              fontSize: 60,
              color: "red",
            }}
          />
        );
      case "confirm":
        return (
          <HelpOutline
            fontSize="medium"
            sx={{
              fontSize: 60,
              color: "#f57c00",
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      //   fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          py: { xs: 1, sm: 2 },
          px: { xs: 1.5, sm: 3 },
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          {getIcon()}
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" },
              color:
                type === "error" ? "error.main" : type === "success" ? "green" : "text.primary",
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              textAlign: "center",
            }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: { xs: 1.5, sm: 2 },
          gap: { xs: 1, sm: 2 },
          flexWrap: "wrap",
        }}
      >
        {type === "confirm" ? (
          <>
            <Button
              onClick={onClose}
              variant="contained"
              size="small"
              sx={{
                color: "beige",
                fontWeight: "bold",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              color="error"
              size="small"
              sx={{
                color: "black",
                fontWeight: "bold",
              }}
            >
              Confirm
            </Button>
          </>
        ) : (
          <Button
            onClick={onClose}
            variant="contained"
            size="small"
            sx={{
              color: "beige", // change text color
              fontWeight: "bold",
            }}
          >
            Okay
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertBox;
